<dynamic-material-form
  #form
  [model]="formModel"
  [group]="formGroup"
  (change)="onFormChange($event)"
  (matEvent)="onCustomEvent($event, null, true)"
  data-test="gsm-gebaeude-schaden_form"
>
</dynamic-material-form>
